import styled from 'styled-components';

const PageContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 4rem 2rem;

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
  }
`;

const Title = styled.h1`
  font-size: 1.8rem;
  margin: 0 0 2rem;
  color: ${({ theme }) => theme.colors.ink};
  font-family: ${({ theme }) => theme.fonts.main};
  text-transform: uppercase;
  letter-spacing: 0.1em;
  text-align: center;
  font-weight: normal;
`;

const Section = styled.section`
  margin-bottom: 2.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

const SectionTitle = styled.h2`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.brownDark};
  font-family: ${({ theme }) => theme.fonts.mono};
  text-transform: uppercase;
  letter-spacing: 0.15em;
  margin: 0 0 1rem;
  font-weight: bold;
`;

const Paragraph = styled.p`
  line-height: 1.8;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.colors.ink};
  font-size: 0.95rem;
  font-family: ${({ theme }) => theme.fonts.body};
  text-align: justify;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Disclaimer = () => {
  return (
    <PageContainer>
      <Title>Methodology & Disclaimer</Title>
      
      <Section>
        <SectionTitle>Our Mission</SectionTitle>
        <Paragraph>
          The Epstein Archive is a public resource dedicated to making the vast collection of documents related to the Jeffrey Epstein case accessible, searchable, and understandable. We aim to provide a centralized platform for researchers, journalists, and the public to explore the primary sources without editorial bias.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>AI & Methodology</SectionTitle>
        <Paragraph>
          We utilize impartial artificial intelligence to process and summarize the thousands of pages of legal documents, flight logs, and other records in this archive. Our AI models are designed to extract factual information and generate neutral summaries to help users navigate the complexity of the material.
        </Paragraph>
        <Paragraph>
          The statistical data presented on the "Stats" page is derived using standard statistical methods applied to the structured data extracted from these documents. We strive for accuracy but acknowledge that the volume and nature of the source material may lead to occasional inconsistencies.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Disclaimer</SectionTitle>
        <Paragraph>
          The information presented on this website is for educational and informational purposes only. We do not take any position or opinion on the guilt or innocence of any individuals mentioned in the documents, nor do we endorse any specific narrative. The inclusion of any person's name or details is solely a reflection of their presence in the public record.
        </Paragraph>
        <Paragraph>
          While we strive to ensure the accuracy of the information presented, we cannot guarantee that all data is free from error. Users are encouraged to consult the original documents, which are linked throughout the site, to verify information.
        </Paragraph>
      </Section>
    </PageContainer>
  );
};

export default Disclaimer;
